export default {
  SET_CLUBS(state, clubs) {
    state.allClubs = clubs
  },
  SET_DEFAULT_CLUB(state, club) {
    state.defaultClubs = club
  },
  SET_SELECTED_CLUB(state, club) {
    state.selectedClub = club
  },
  SET_CLUB_INDEX(state, index) {
    state.chosenClubIndex = index
  },
  CLEAR_CLUB_INDEX(state) {
    state.chosenClubIndex = 0
  }
}



// WEBPACK FOOTER //
// ./src/store/clubs/clubs.mutations.js